export const googleMapsMarkerText = 'text-md-bold !text-base-white'

export const mapboxMarkerText =
   'z-10 absolute top-[8px] left-1/2 -translate-x-1/2 text-md-bold text-white'

export const mapboxMarkerContainer =
   'absolute bottom-0 left-1/2 -translate-x-1/2 shrink-0 w-[36px] h-[44px]'
